import {useQueryParams} from '@aboutyou/router';

export const useShouldShowPDLoginBanner = () => {
  const queryParams = useQueryParams();
  let loginReason = queryParams.get('loginReason');
  const fromQueryParam = queryParams.get('from');
  if (!loginReason && fromQueryParam) {
    const decodedQueryParams = new URLSearchParams(
      decodeURIComponent(fromQueryParam).split('?')[1],
    );
    loginReason = decodedQueryParams.get('loginReason');
  }

  return loginReason === 'personal-reduction';
};
